var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-btn',{class:{ 'active': !_vm.disabled, 'active-disable': _vm.activeDisable },attrs:{"variant":"link","disabled":_vm.disabled || _vm.activeDisable},on:{"click":_vm.onClick}},[_c('i',{class:`${_vm.iconStyle} ${_vm.icon}`})])
}
var staticRenderFns = []

export { render, staticRenderFns }